import { useCallback } from 'react';
import { useGetPuck } from '@puckeditor/core';
import { useBlockPropsWriter } from './blockPropsWriter';

/**
 * Un contrôle posé au-dessus de l'overlay Puck (`data-puck-overlay-portal`)
 * ne sélectionne plus sa box : le clic retombe sur le Bloc. `select()` la
 * resélectionne. Éditeur seulement : `useGetPuck` n'existe pas sur le site.
 */
export default function WithBlockSelection({ blockId, children }) {
  const getPuck = useGetPuck();
  const writer = useBlockPropsWriter();
  const select = useCallback(() => {
    if (!blockId || writer) return;
    const { dispatch, getSelectorForId } = getPuck();
    const itemSelector = getSelectorForId(blockId);
    if (itemSelector) dispatch({ type: 'setUi', ui: { itemSelector } });
  }, [blockId, getPuck, writer]);
  return children(select);
}

export const noSelection = ({ children }) => children(() => {});
